import {remCalc} from '_themeUtils'

const textStyles = {
    textStyles: {
        dispaly2Xl: {
            fontSize: remCalc(72),
            lineHeight: remCalc(80),
            letterSpacing: '0.02em',
        },
        displayXl: {
            fontSize: remCalc(46),
            lineHeight: remCalc(53),
            letterSpacing: '0.02em',
        },
        displayLg: {
            fontSize: remCalc(36),
            lineHeight: remCalc(42),
            letterSpacing: '0.02em',
        },
        displayMd: {
            fontSize: remCalc(32),
            lineHeight: remCalc(36),
            letterSpacing: '0.02em',
        },
        displaySm: {
            fontSize: remCalc(28),
            lineHeight: remCalc(32),
            letterSpacing: '0.02em',
        },
        displayXs: {
            fontSize: remCalc(24),
            lineHeight: remCalc(28),
            letterSpacing: '0.02em',
        },
        paragraphXl: {
            fontSize: remCalc(20),
            lineHeight: remCalc(26),
            letterSpacing: '0.05em',
        },
        paragraphLg: {
            fontSize: remCalc(18),
            lineHeight: remCalc(24),
            letterSpacing: '0.05em',
        },
        paragraphMd: {
            fontSize: remCalc(16),
            lineHeight: remCalc(20),
            letterSpacing: '0.05em',
        },
        paragraphSm: {
            fontSize: remCalc(14),
            lineHeight: remCalc(17),
            letterSpacing: '0.05em',
        },
        paragraphXs: {
            fontSize: remCalc(12),
            lineHeight: remCalc(14),
            letterSpacing: '0.05em',
        },
        paragraphXxs: {
            fontSize: remCalc(10),
            lineHeight: remCalc(12),
            letterSpacing: '0.05em',
        },
        buttonXs: {
            fontSize: remCalc(12),
            lineHeight: remCalc(14),
            letterSpacing: '0.2em',
        },
        buttonSm: {
            fontSize: remCalc(14),
            lineHeight: remCalc(17),
            letterSpacing: '0.2em',
        },
        buttonMd: {
            fontSize: remCalc(16),
            lineHeight: remCalc(20),
            letterSpacing: '0.2em',
        },
        buttonLg: {
            fontSize: remCalc(24),
            lineHeight: remCalc(28),
            letterSpacing: '0.2em',
        },
        buttonLinkMd: {
            fontSize: remCalc(16),
            lineHeight: remCalc(24),
            letterSpacing: '0.2em',
        },
        tagMd: {
            fontSize: {base: remCalc(10), lg: remCalc(14)},
            lineHeight: 1,
        },
    },
}

export default textStyles
